import React, { useMemo, useState } from 'react'
import { Spin, Table } from 'antd'
import { useRequest } from 'ahooks'
import Button from '@/components/button/button'
import { BaseDialog } from '@/components/dialog/base-dialog'
import $msg from '@/utils/message'
import Auth from '@/views/main/components/auth/auth'
import { getMemberLevelList } from '../api'
import MemberLevel from '../member-level/member-level'
import SettingPage, { SettingGrid, SettingPanel, SettingTableContainer } from './setting-page'

const benefitLabels: Record<string, string> = {
    benefit_recharge_bonus: '充值送',
    benefit_member_price: '商品会员价',
    benefit_member_discount: '会员折扣',
    benefit_point_booster: '多倍积分',
    benefit_deduction_points: '积分抵现',
    benefit_broadcast: '尊享播报',
}

const MemberBenefit: React.FC = () => {
    const [levelDialogVisible, setLevelDialogVisible] = useState(false)
    const levelReq = useRequest(getMemberLevelList, {
        onError: e => $msg('error', e.message || '获取会员权益失败'),
    })

    const columns = useMemo(
        () => [
            { title: '会员等级', dataIndex: 'name', width: 92 },
            {
                title: '成长值门槛',
                dataIndex: 'experience_threshold',
                width: 112,
            },
            {
                title: '已拥有权益',
                render: (_: any, record: any) => {
                    const benefits = record.benefits || {}
                    const tags = Object.keys(benefits)
                        .filter(key => benefits[key]?.if_has)
                        .map(key => (
                            <span className="member-tag" key={key}>
                                {benefitLabels[key] || key}
                            </span>
                        ))

                    return tags.length ? tags : <span>暂无权益</span>
                },
            },
        ],
        [],
    )

    return (
        <SettingPage
            title="会员权益"
            append={
                levelDialogVisible ? (
                    <div className="member-level-dialog-layer">
                        <BaseDialog
                            isShow
                            title="编辑会员等级"
                            width={1120}
                            onClose={() => setLevelDialogVisible(false)}
                        >
                            <MemberLevel dialog onChanged={levelReq.refresh} />
                        </BaseDialog>
                    </div>
                ) : null
            }
        >
            <Spin spinning={levelReq.loading}>
                <SettingGrid>
                    <SettingPanel
                        title="等级权益概览"
                        desc="会员权益由等级、折扣、会员价、积分和付费会员等规则共同决定。"
                        extra={
                            <Auth perssion={20} onClick={() => setLevelDialogVisible(true)}>
                                <Button types="default">编辑会员等级</Button>
                            </Auth>
                        }
                        wide
                    >
                        <SettingTableContainer>
                            <Table
                                bordered
                                rowKey="id"
                                columns={columns}
                                dataSource={levelReq.data || []}
                                pagination={false}
                            />
                        </SettingTableContainer>
                    </SettingPanel>
                </SettingGrid>
            </Spin>
        </SettingPage>
    )
}

export default MemberBenefit
